/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Compiled, { MultiValueContainer as CompiledMultiValueContainer, multiValueCSS as CompiledMultiValueCSS, MultiValueLabel as CompiledMultiValueLabel, multiValueLabelCSS as CompiledMultiValueLabelCSS, MultiValueRemove as CompiledMultiValueRemove, multiValueRemoveCSS as CompiledMultiValueRemoveCSS } from '../compiled/components/multi-value';
import Emotion, { MultiValueContainer as EmotionMultiValueContainer, multiValueCSS as EmotionMultiValueCSS, MultiValueLabel as EmotionMultiValueLabel, multiValueLabelCSS as EmotionMultiValueLabelCSS, MultiValueRemove as EmotionMultiValueRemove, multiValueRemoveCSS as EmotionMultiValueRemoveCSS } from '../emotion/components/multi-value';
export var multiValueCSS = function multiValueCSS(props) {
  return fg('compiled-react-select') ? CompiledMultiValueCSS() : EmotionMultiValueCSS(props);
};
export var multiValueLabelCSS = function multiValueLabelCSS(props) {
  return fg('compiled-react-select') ? CompiledMultiValueLabelCSS() : EmotionMultiValueLabelCSS(props);
};
export var multiValueRemoveCSS = function multiValueRemoveCSS(props) {
  return fg('compiled-react-select') ? CompiledMultiValueRemoveCSS() : EmotionMultiValueRemoveCSS(props);
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MultiValueContainer = function MultiValueContainer(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledMultiValueContainer, props) : /*#__PURE__*/React.createElement(EmotionMultiValueContainer, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MultiValueLabel = function MultiValueLabel(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledMultiValueLabel, props) : /*#__PURE__*/React.createElement(EmotionMultiValueLabel, props);
};
export function MultiValueRemove(props) {
  return (
    // The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledMultiValueRemove, props) : /*#__PURE__*/React.createElement(EmotionMultiValueRemove, props)
  );
}
var MultiValue = function MultiValue(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(Compiled, props) : /*#__PURE__*/React.createElement(Emotion, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default MultiValue;